import { GwtConfig } from 'OK/GwtConfig';
import { StatLogger } from 'OK/StatLogger';

let instance: GwtExperimentsCfg | null = null;

export interface IGwtExperimentsCfgData {
    /** включение реализации urlExtension на JS */
    removeUrlExtension: boolean;
    /** включение реализации хука для коротких ссылок на JS */
    removeShortLinkHook: boolean;
    /** включение логирования ts/js модулей */
    modulesLoggingEnabled?: boolean;
    /** Регулярное выражение для модулей, которые логируем */
    modulesLoggingPattern?: string;
    /** блэклист тех типов ошибок, для которых мы не показывает алёрт */
    alertClientErrorBlackListByOperation?: string[];
    /** блэклист тех ошибок с place, для которых мы не показывает алёрт */
    alertClientErrorBlackListByPlace?: string[];

    gok?: boolean;
    gokStates?: string[];
    gokNotStates?: string[];
    okDomain?: string;
}

/**
 * Класс для конфигурации экспериментов GWT.
 * Чтобы получить необходимый конфиг, для начала его нужно зарендерить
 * в `one.app.community.dk.blocks.user.conf.exprm.ExperimentsConfigRBlock` в json формате.
 * Названия конфигураций находятся в `one.app.community.dk.gwt.hook.client.hooks.conf.GwtExperimentsCfg`.
 * При первом обращении к классу он возьмет innerHtml специального блока конфигураций (id='hook_Cfg_GwtExperimentsCfg')
 * и запарсит все конфиги, находящиеся там, затем положит их в поле `data`.
 */
export class GwtExperimentsCfg extends GwtConfig<IGwtExperimentsCfgData> {
    constructor() {
        super('GwtExperimentsCfg');
    }

    public isRemoveUrlExtension(): boolean {
        return !!this.data?.removeUrlExtension;
    }

    public isRemoveShortLinkHook(): boolean {
        return !!this.data?.removeShortLinkHook;
    }

    public isModulesLoggingEnabled(): boolean {
        return !!this.data?.modulesLoggingEnabled;
    }

    public isShownAlertForThisError(place: string, operation: string): boolean {
        return !this.data?.alertClientErrorBlackListByPlace?.includes(place)
            && !this.data?.alertClientErrorBlackListByOperation?.includes(operation);
    }

    public getModulesLoggingPattern(): RegExp | null {
         const { modulesLoggingPattern } = this.data;
         let result = null;

         try {
             if (modulesLoggingPattern) {
                 result = new RegExp(modulesLoggingPattern);
             }
         } catch (e) {
             StatLogger.error('failedParseLoggingModulePattern', (e as Error)?.message);
         }

         return result;
    }

    public isGok(): boolean {
        return !!this.data?.gok;
    }

    public isGokLink(source: string): boolean {
        if (this.data?.gokStates) {
            for (let i = 0; i < this.data.gokStates.length; i++) {
                if (source.includes(this.data.gokStates[i])) {
                    let ignore = false;
                    if (this.data?.gokNotStates) {
                        for (let j = 0; j < this.data.gokNotStates.length; j++) {
                            if (source.includes(this.data.gokNotStates[j])) {
                                ignore = true;
                                break;
                            }
                        }
                    }

                    if (!ignore) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    public gokToPortal(link: string): string {
        if (!link.includes('://')) {
            return `${this.data?.okDomain || ''}${link.startsWith('/') ? link.substring(1) : link}`;
        }

        return link;
    }

    public static getInstance(): GwtExperimentsCfg {
        if (!instance) {
            instance = new GwtExperimentsCfg();
        }
        return instance;
    }
}

export const getInstance = GwtExperimentsCfg.getInstance;
